import { HospitalCategoryModel } from './hospital_category.model';

export class HospitalModel {
	Id: string;
	HospitalCode: string;
	HospitalCategoryId: number;
	Name: string;
	LocLat: number;
	LocLongt: number;
	HospitalCategory: HospitalCategoryModel;
}
